import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import BoxGeneratorPage from './BoxGeneratorPage';

const manifest = {
  id: 'box-generator',
  nameKey: 'extensions.box_generator.name',
  descriptionKey: 'extensions.box_generator.description',
  icon: Inventory2OutlinedIcon,
  route: '/box-generator',
  menuItem: {
    labelKey: 'extensions.box_generator.menu',
    path: '/box-generator',
  },
  requiredExtensions: [],
  Page: BoxGeneratorPage,
};

export default manifest;
